<template>
  <div id="pageDashboard">
    <v-container grid-list-xl fluid>
      <v-layout row wrap v-if="show">
        <v-flex lg12>
          <v-card v-if="show3">
            <v-card-text>
              <h3>Tidak Ada Jadwal Hari Ini</h3>
            </v-card-text>
          </v-card>
          <v-card v-if="show3 == false">
            <v-card-text>
              <v-card-title>
                <h3>Jadwal Hari Ini</h3>
              </v-card-title>
              <v-divider></v-divider>
              <v-layout wrap>
                <v-flex xs12 lg6>
                    <h3><b>{{tanggal}}</b></h3>
                </v-flex>

                <!--<v-flex xs12 lg6>-->
                  <!--<v-select-->
                    <!--v-model="type"-->
                    <!--:items="typeOptions"-->
                    <!--label="Type"-->
                  <!--&gt;</v-select>-->
                <!--</v-flex>-->
              </v-layout>
            </v-card-text>
            
            <v-divider></v-divider>
            <v-layout wrap>
              <v-flex
                xs12
                class="mb-3"
              >
                <v-sheet height="100">
                    <Calendar :event= events :type=type />
                </v-sheet>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      
      <v-layout row wrap v-if="show2">
        <!-- mini statistic start -->
        <v-flex lg3 sm6 xs12 @click="onTotal">
          <mini-statistic
            statistic-name="Total Peminjaman Keseluruhan"
            :title="count"
            sub-title="Peminjaman"
            color="indigo">
          </mini-statistic>
        </v-flex>
        <v-flex lg3 sm6 xs12 @click="onTotal2">
          <mini-statistic statistic-name="Total Peminjaman Disetujui" :title="countSetuju" sub-title="Peminjaman" color="light-blue"> </mini-statistic>
        </v-flex>
        <v-flex lg3 sm6 xs12 @click="onTotal3">
          <mini-statistic statistic-name="Total Peminjaman Dibatalkan" :title="countBatal" sub-title="Peminjaman" color="orange lighten-2"> </mini-statistic>
        </v-flex>
        <v-flex lg3 sm6 xs12 @click="onTotal4">
          <mini-statistic statistic-name="Total Peminjaman Ditolak" :title="countTolak" sub-title="Peminjaman" color="red"> </mini-statistic>
        </v-flex>
        <!-- mini statistic  end -->
        <!--<v-flex lg12>-->
          <!--<plain-table card-title="Statistik Peminjam"></plain-table>-->
        <!--</v-flex>-->
        <!--<v-flex lg12>-->
          <!--<plain-table-order></plain-table-order>-->
        <!--</v-flex>-->
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {base} from "../../setup-axios"
import {baseEUIS} from "../../setup-axios(euis)"
import MiniStatistic from "@/componentsSiRuang/widgets/statistic/MiniStatistic"
import PlainTable from "@/componentsSiRuang/widgets/list/PlainTable"
import PlainTableOrder from "@/componentsSiRuang/widgets/list/PlainTableOrder"
import {createJWT, getJWT } from '../../store/module/helper'

import moment from 'moment'
import MonthCalendar from './MonthCalendar'
import Calendar from './Calendar'

export default {
  components: {
    MiniStatistic,
    PlainTable,
    PlainTableOrder,
    MonthCalendar,
    Calendar
  },
  data() {
    return {
      tanggal : moment().format('MMMM') + " " + moment().format('YYYY'),
      role : localStorage.getItem("role"),
      type: 'week',
      start: '',
      end: '',
      typeOptions: [
        { text: 'Day', value: 'day' },
        { text: 'Week', value: 'week' },
        { text: 'Month', value: 'month' }
      ],
      count: 0,
      countSetuju: 0,
      countBatal: 0,
      countTolak: 0,
      jadwal: [],
      events: []
    }
  },

  created(){
    // this.$refs.calendar.scrollToTime('07:00')
    var jwt = getJWT()
    var month  = moment().format('MMMM');
    var year = moment().format('YYYY');
    console.log(year)


    if(this.role == "admin"){
      base.get("penggunaanRuangan",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        console.log(resp.data.result)
        this.count = resp.data.result.length
      })

      base.get("penggunaanRuangan/admin/status/3",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        this.countSetuju = resp.data.result.length
      })

      base.get("penggunaanRuangan/admin/status/4",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        this.countBatal = resp.data.result.length
      })

      base.get("penggunaanRuangan/admin/status/2",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        this.countTolak = resp.data.result.length
      })
    }

    if(this.role == "RT"){
      base.get("penggunaanRuangan/non-akademik/status/0",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        this.count = resp.data.result.length
      })

      base.get("penggunaanRuangan/non-akademik/status/3",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        this.countSetuju = resp.data.result.length
      })

      base.get("penggunaanRuangan/non-akademik/status/4",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        this.countBatal = resp.data.result.length
      })

      base.get("penggunaanRuangan/non-akademik/status/2",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        this.countTolak = resp.data.result.length
      })
    }
    if(this.role == "ruang"){
      base.get("penggunaanRuangan/akademik/status/0",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        this.count = resp.data.result.length
      })

      base.get("penggunaanRuangan/akademik/status/3",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        this.countSetuju = resp.data.result.length
      })

      base.get("penggunaanRuangan/akademik/status/4",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        this.countBatal = resp.data.result.length
      })

      base.get("penggunaanRuangan/akademik/status/2",
           {
             headers: {
               Authorization: createJWT()
             }
           }
      ).then((resp) => {
        this.countTolak = resp.data.result.length
      })
    }

    base.get("penggunaanRuangan/getJadwalUser", {
        headers : {
          'Authorization': createJWT(),
          'token' : jwt,
          'who' : localStorage.getItem('role'),
          'noInduk' : localStorage.getItem('no_induk')
        }
      }).then((resp) => {
        for(var i=0; i < resp.data.result.length; i++){

          var date1 = new Date(resp.data.result[i].mulai)
          var date2 = new Date(resp.data.result[i].selesai)
          var res = Math.abs(date2 - date1) / 1000
          var menit

          if(Math.floor(res/60)% 60 == 0){
            menit = Math.floor(res / 60)
          }

          else {
            menit = Math.floor(res/60)% 60
          }
          console.log(menit)

          this.events.push({
            title : resp.data.result[i].deskripsi,
            details : resp.data.result[i].deskripsi,
            date : resp.data.result[i].mulai.substring(0,10),
            open : false,
            time : resp.data.result[i].mulai.substring(11,16),
            duration: menit,
            gedung : resp.data.result[i].gedung,
            lokasi : resp.data.result[i].namaLokasi,
            ruangan : resp.data.result[i].namaRuangan,
            selesai : resp.data.result[i].selesai.substring(11,16)
          })
        }
    })
  },

  computed: {
    show: function () {
      this.role;
      return this.role == "mhs" || this.role == "dos";
    },

    typeCalender: function(){
      return this.type;
    },

    // convert the list of events into a map of lists keyed by date
    eventsMap () {
      console.log(this.$refs)
      console.log(this.$slots)
      const map = {}
      this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
      console.log(map)
      return map
    },

    show2: function () {
      this.role;
      return this.role == "admin" || this.role == "RT" || this.role == "ruang";
    },
    show3: function(){
      if(this.events.length == 0){
        return true
      }

      else {
        return false
      }
    }
  },

  methods: {
    onTotal(){
      localStorage.setItem("flagTab",4)
      this.$router.push("/peminjaman/peminjaman")
    },

    onTotal2(){
      localStorage.setItem("flagTab",1)
      this.$router.push("/peminjaman/peminjaman")
    },

    onTotal3(){
      localStorage.setItem("flagTab",3)
      this.$router.push("/peminjaman/peminjaman")
    },

    onTotal4(){
      localStorage.setItem("flagTab",2)
      this.$router.push("/peminjaman/peminjaman")
    },
  }
}
</script>

<style lang="stylus" scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
  }

   &.with-time {
      position: absolute;
      right: 4px;
      margin-right: 0px;
    }
</style>

